/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";

const StyledStockLabel = styled.div`
  .item_stock {
    padding: 0.7em;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: white;
    border-radius: 2px;
  }
  .grey {
    color: black;
    background-color: #efefef;
  }
  .yellow {
    background-color: #e69f19;
  }
  .red {
    background-color: #ce0818;
  }
`;

interface StockLabelProps {
  stock?: Number;
}

const StockLabel: React.FC<StockLabelProps> = ({ stock }) => {
  return (
    <StyledStockLabel>
      {stock && stock > 0 ? (
        stock > 5 ? (
          <span className="item_stock grey">
            Quedan {parseFloat(stock).toFixed(0)} unidades
          </span>
        ) : (
          <span className="item_stock yellow">
            Quedan {parseFloat(stock).toFixed(0)} unidades
          </span>
        )
      ) : (
        <span className="item_stock red">Sin stock</span>
      )}
    </StyledStockLabel>
  );
};

export default StockLabel;
